import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _inherits from "@babel/runtime/helpers/inherits";
import _createSuper from "@babel/runtime/helpers/createSuper";
import { ClientCollection } from "..";

var AbstractCategoryCollection = /*#__PURE__*/function (_ClientCollection) {
  _inherits(AbstractCategoryCollection, _ClientCollection);

  var _super = _createSuper(AbstractCategoryCollection);

  function AbstractCategoryCollection() {
    _classCallCheck(this, AbstractCategoryCollection);

    return _super.apply(this, arguments);
  }

  return AbstractCategoryCollection;
}(ClientCollection);

export { AbstractCategoryCollection };